import type { CopyCatalog } from "./copyTypes";

export const ES_COPY: CopyCatalog = {
  "common.loading": "Cargando…",
  "common.yes": "Sí",
  "common.no": "No",
  "common.notProvided": "No indicado",
  "common.notRequired": "No requerido",
  "common.requested": "Solicitado",
  "nav.back": "Atrás",
  "nav.continue": "Continuar",
  "nav.sendRequest": "Enviar solicitud",
  "nav.sending": "Enviando…",
  "alert.completeFields": "Complete los campos marcados antes de continuar.",
  "fill.filled": "Completado",
  "fill.notFound": "No encontrado",
  "fill.shipmentToo": "Envío también completado: {detail}",
  "fill.palletMany": "palés",

  "choose.title": "¿Cómo desea solicitar su presupuesto?",
  "choose.manual.title": "Entrada manual",
  "choose.manual.description": "Introduzca los datos de su envío paso a paso con el formulario guiado.",
  "choose.manual.action": "Introducir datos manualmente",
  "choose.quickfill.title": "Quick Fill",
  "choose.quickfill.description":
    "Pegue los datos del envío o suba un documento y rellenaremos el formulario por usted.",
  "choose.quickfill.action": "Iniciar relleno rápido",

  "steps.route": "Ruta y pedido",
  "steps.shipment": "Envío",
  "steps.services": "Servicios adicionales",
  "steps.contact": "Contacto",
  "steps.review": "Revisar",

  "page.route": "Ruta y pedido",
  "page.routeSection": "Ruta",
  "page.shipment": "Datos del envío",
  "page.services": "Servicios adicionales",
  "page.contact": "Datos de contacto",
  "page.contactSection": "Sus datos de contacto",
  "page.review": "Revisar",
  "page.quickFill": "Quick Fill",
  "page.analyzing": "Analizando su documento",

  "route.hintPostcode": "Introduzca un código postal o una ciudad para carga y descarga.",
  "route.hintFullAddress": "Introduzca la dirección completa de carga y descarga.",
  "route.unsupported": "Esta ruta no se admite. Utilice el formulario para {loadCountry} y {unloadCountry}.",
  "route.loading": "Carga",
  "route.unloading": "Descarga",
  "route.origin": "Origen",
  "route.destination": "Destino",
  "route.country": "País",
  "route.selectCountry": "Seleccionar país",
  "route.postcode": "Código postal",
  "route.postcodePlaceholder": "p. ej. 28001",
  "route.city": "Ciudad",
  "route.cityPlaceholder": "Introducir ciudad",
  "route.street": "Nombre de la calle",
  "route.streetPlaceholder": "Introducir calle",
  "route.house": "Número",
  "route.housePlaceholder": "p. ej. 12",
  "route.pickupDate": "Fecha de recogida preferida:",
  "route.unloadDate": "Fecha de descarga preferida:",
  "route.datePlaceholder": "dd/mm/aaaa",
  "date.clear": "Borrar fecha",
  "date.closeCalendar": "Cerrar calendario",
  "date.openCalendar": "Abrir calendario",
  "route.specificDateHint":
    "Para mercancías disponibles en una fecha concreta. En caso contrario, buscamos la opción más rápida.",
  "route.orderDetails": "Datos del pedido",

  "shipment.goods": "Descripción de las mercancías",
  "shipment.goodsPlaceholder": "¿Qué desea transportar?",
  "shipment.weight": "Peso total",
  "shipment.qty": "Cant.",
  "shipment.type": "Tipo",
  "shipment.dims": "Dimensiones / LDM",
  "shipment.stackable": "Apilable",
  "shipment.addRow": "Añadir línea de envío",
  "shipment.totalLines": "Total de líneas: {count}",
  "shipment.selectDims": "Seleccionar dimensiones",
  "shipment.dimsNa": "Dimensiones no aplicables",
  "shipment.sizeModeDims": "L × An × Al",
  "shipment.sizeModeLdm": "LDM",
  "shipment.removeRow": "Eliminar línea de envío {n}",
  "shipment.lineLabel": "{text}, línea {n}",
  "shipment.quantity": "Cantidad",
  "qty.decrease": "Reducir cantidad",
  "qty.increase": "Aumentar cantidad",
  "shipment.lengthCm": "Longitud (cm)",
  "shipment.widthCm": "Anchura (cm)",
  "shipment.heightCm": "Altura (cm)",
  "shipment.dimensions": "Dimensiones",
  "shipment.size": "Tamaño",
  "shipment.ldm": "LDM",

  "pallet.euro": "Euro",
  "pallet.block": "Block",
  "pallet.ibc": "IBC",
  "pallet.cp3": "CP3",
  "pallet.half": "Media paleta",
  "pallet.size80x60": "80×60",
  "pallet.size120x120": "120×120",
  "pallet.size150x80": "150×80",
  "pallet.custom": "A medida",
  "pallet.unspecified": "LDM",

  "services.aria": "Servicios adicionales",
  "services.pill.adr": "ADR",
  "services.pill.temp": "Temperatura",
  "services.pill.tail": "Plataforma elevadora",
  "services.pill.ftl": "FTL",
  "services.pill.time": "Franja horaria",
  "services.pill.ref": "Referencia / notas",
  "services.pill.references": "Referencias",
  "services.pill.attachments": "Adjuntos adicionales",
  "services.adrClass": "Clase ADR",
  "services.selectClass": "Seleccionar clase",
  "services.unNumber": "Número ONU",
  "services.unPlaceholder": "p. ej. 1203",
  "services.min": "Mín",
  "services.max": "Máx",
  "services.tailLoad": "Plataforma elevadora en la carga",
  "services.tailUnload": "Plataforma elevadora en la descarga",
  "services.ftlCopy": "Carga completa solicitada.",
  "services.invoiceRef": "Referencia de factura",
  "services.reference": "Referencia",
  "services.loadingRef": "Referencia de carga",
  "services.unloadingRef": "Referencia de descarga",
  "services.notes": "Notas",
  "services.notesPlaceholder": "p. ej. instrucciones especiales",
  "services.deadline": "Fecha límite de entrega preferida:",
  "services.deliveryHint":
    "Para mercancías que deban entregarse en una fecha concreta. En caso contrario, buscamos la opción más rápida.",
  "services.loadingTime": "Hora de carga",
  "services.unloadingTime": "Hora de descarga",
  "services.window": "Franja",
  "services.fixed": "Fija",
  "services.at": "a las",
  "services.from": "desde",
  "services.to": "hasta",
  "services.timeTypeAria": "Tipo de {title}",
  "services.addFiles": "Añadir archivos",
  "services.attachHint":
    "JPEG, PNG, GIF, WebP o PDF. Hasta {maxFiles} archivos, {maxFileMb} MB cada uno, {maxTotalMb} MB en total.",
  "services.adrClass1": "1 Materias explosivas",
  "services.adrClass2": "2 Gases",
  "services.adrClass3": "3 Líquidos inflamables",
  "services.adrClass4": "4 Materias sólidas inflamables",
  "services.adrClass5": "5 Materias comburentes",
  "services.adrClass6": "6 Materias tóxicas / infecciosas",
  "services.adrClass7": "7 Materias radiactivas",
  "services.adrClass8": "8 Materias corrosivas",
  "services.adrClass9": "9 Materias y objetos peligrosos diversos",
  "services.summary.adr": "Mercancías peligrosas (ADR)",
  "services.summary.temp": "Temperatura controlada",
  "services.summary.time": "Franjas horarias",
  "services.summary.refNotes": "Referencia y notas",
  "services.summary.tail": "Plataforma elevadora",
  "services.summary.ftl": "FTL",
  "services.summary.attachments": "Adjuntos adicionales",
  "services.tail.loadUnload": "Carga y descarga",
  "services.tail.loadOnly": "Solo carga",
  "services.tail.unloadOnly": "Solo descarga",
  "services.time.load": "Carga: {value}",
  "services.time.unload": "Descarga: {value}",
  "services.time.deadline": "Plazo: {value}",
  "services.time.fixedSuffix": "{time} (fija)",
  "services.time.windowRange": "{from} a {until}",
  "services.adr.yes": "Sí",
  "services.adr.classUn": "Clase {class}, ONU {un}",
  "services.adr.classOnly": "Clase {class}",
  "services.adr.unOnly": "ONU {un}",
  "services.temp.range": "{min}°C a {max}°C",
  "services.ref.invoice": "Factura: {value}",
  "services.ref.loading": "Carga: {value}",
  "services.ref.unloading": "Descarga: {value}",

  "contact.name": "Nombre",
  "contact.company": "Empresa",
  "contact.email": "Correo electrónico",
  "contact.phone": "Teléfono",
  "contact.comment": "Comentario adicional",
  "contact.privacyBefore":
    "Acepto el tratamiento de mis datos personales de acuerdo con la ",
  "contact.privacyLink": "política de privacidad",
  "contact.privacyAfter": " de Neele-Vat.",

  "result.thankYou": "¡Gracias! Hemos recibido su solicitud.",
  "result.teamWillContact":
    "Nuestro equipo se pondrá en contacto con usted en 60 minutos en horario de oficina.",
  "result.teamWillContactEmail":
    "Nuestro equipo se pondrá en contacto con usted en 60 minutos en horario de oficina en {email}.",
  "result.previewMode": "Modo de vista previa: esta solicitud no se ha enviado realmente.",
  "result.previewFiles": " Nota: los archivos no se pueden enviar en el modo de vista previa.",
  "result.yourReference": "Su referencia",
  "result.copy": "Copiar",
  "result.copied": "Copiado",
  "result.nextTitle": "Qué ocurre a continuación",
  "result.next1": "Solicitud recibida.",
  "result.next2": "Solicitud en revisión.",
  "result.next3": "Respuesta en 60 minutos por correo electrónico.",
  "result.logged":
    "Hemos registrado su solicitud. Si no tiene noticias, póngase en contacto con nosotros con los datos siguientes.",
  "result.newQuote": "Iniciar un nuevo presupuesto",
  "result.sendFailed": "No hemos podido enviar su solicitud",
  "result.preferDirect": "¿Prefiere contactarnos directamente?",
  "result.backToEdit": "Volver a editar",
  "result.tryAgain": "Intentar de nuevo",
  "result.hideDetails": "Ocultar detalles",
  "result.viewSent": "Ver lo que hemos enviado",
  "result.error.rateLimited":
    "Ha realizado muchas solicitudes en poco tiempo. Espere un momento e inténtelo de nuevo.",
  "result.error.forbidden":
    "Esta solicitud se ha bloqueado. Inténtelo de nuevo o contáctenos directamente.",
  "result.error.network":
    "No hemos podido enviar su solicitud ahora. Compruebe su conexión e inténtelo de nuevo.",
  "result.error.tooLarge":
    "Esta solicitud es demasiado grande. Use adjuntos más pequeños o un comentario más corto.",
  "result.error.unsupportedType": "Use solo archivos JPEG, PNG, GIF, WebP o PDF.",
  "result.error.emailUnavailable":
    "No hemos podido enviar su solicitud con los adjuntos. Inténtelo de nuevo o contáctenos directamente.",

  "qf.hint":
    "Pegue un correo o datos de envío, o adjunte una imagen o PDF. Esto sustituye los datos ya introducidos.",
  "qf.placeholder":
    "p. ej. 24 palets euro de 3011 Róterdam a 20095 Hamburgo, 12.000 kg, recogida mañana…",
  "qf.ariaPaste": "Datos de envío para analizar",
  "qf.attach": "Adjuntar imagen o PDF",
  "qf.disclaimer":
    "Lo que pegue o adjunte se usa solo para rellenar esta solicitud. Lo procesa nuestro servicio de análisis de documentos y no se guarda una vez rellenado el formulario.",
  "qf.fillForm": "Rellenar formulario",
  "qf.working": "Procesando…",
  "qf.analyzing": "Analizando sus datos…",
  "qf.noFields": "No se han podido reconocer campos. Añada más detalles.",
  "qf.rateLimited": "Ha realizado demasiadas solicitudes. Espere un momento e inténtelo de nuevo.",
  "qf.blocked": "Esta solicitud se ha bloqueado. Contáctenos si esto es inesperado.",
  "qf.extractUnavailable":
    "El análisis de documentos no está disponible ahora. Pegue los datos del envío en su lugar.",
  "qf.genericError": "Algo ha salido mal. Compruebe su red o inténtelo de nuevo.",
  "qf.analyzeTitle": "Analizando su documento...",
  "qf.analyzeSub": "Suele tardar unos segundos",
  "qf.analyzeStep1": "Lectura de la estructura del documento",
  "qf.analyzeStep2": "Extracción de datos básicos",
  "qf.analyzeStep3": "Identificación de líneas de envío",
  "qf.removeFile": "Eliminar {name}",

  "error.loadCountry": "Seleccione un país de carga.",
  "error.loadPostal": "Introduzca el código postal de carga.",
  "error.loadCity": "Introduzca la ciudad de carga.",
  "error.loadStreet": "Introduzca el nombre de la calle de carga.",
  "error.loadHouseNumber": "Introduzca el número de carga.",
  "error.unloadCountry": "Seleccione un país de descarga.",
  "error.unloadPostal": "Introduzca el código postal de descarga.",
  "error.unloadCity": "Introduzca la ciudad de descarga.",
  "error.unloadStreet": "Introduzca el nombre de la calle de descarga.",
  "error.unloadHouseNumber": "Introduzca el número de descarga.",
  "error.pickupDate": "Elija una fecha de recogida.",
  "error.unloadDate": "Elija una fecha de descarga.",
  "error.invalidDate": "Introduzca una fecha válida.",
  "error.totalWeight": "Introduzca el peso total.",
  "error.goods": "Describa las mercancías.",
  "error.loadCityOrPostal": "Introduzca el código postal o la ciudad de carga.",
  "error.unloadCityOrPostal": "Introduzca el código postal o la ciudad de descarga.",
  "error.loadPostalInvalid": "Introduzca un código postal de carga reconocido.",
  "error.loadCityInvalid": "Introduzca una ciudad de carga reconocida.",
  "error.unloadPostalInvalid": "Introduzca un código postal de descarga reconocido.",
  "error.unloadCityInvalid": "Introduzca una ciudad de descarga reconocida.",
  "error.pickupPast": "La fecha de recogida no puede estar en el pasado.",
  "error.unloadPast": "La fecha de descarga no puede estar en el pasado.",
  "error.unloadBeforePickup": "La fecha de descarga no puede ser anterior a la de recogida.",
  "error.weightRange": "Introduzca un peso entre 1 y {max} kg.",
  "error.rangePlain": "{min}–{max}.",
  "error.rangeLdm": "{min}–{max} LDM.",
  "error.rangeCm": "{min}–{max} cm.",
  "error.adrUn": "Introduzca el número ONU de 4 dígitos.",
  "error.invoiceRef": "Introduzca la referencia de factura.",
  "error.loadingRef": "Introduzca la referencia de carga.",
  "error.unloadingRef": "Introduzca la referencia de descarga.",
  "error.tempMin": "Introduzca la temperatura mínima.",
  "error.tempMax": "Introduzca la temperatura máxima.",
  "error.tempOrder": "El máximo debe ser al menos el mínimo.",
  "error.enterNumber": "Introduzca un número.",
  "error.deliveryPast": "La fecha límite de entrega no puede estar en el pasado.",
  "error.deliveryBeforePickup": "La fecha límite de entrega no puede ser anterior a la de recogida.",
  "error.tailSides": "Seleccione carga, descarga o ambas.",
  "error.attachOne": "Adjunte al menos un archivo.",
  "error.enterTime": "Introduzca una hora.",
  "error.enterStartTime": "Introduzca una hora de inicio.",
  "error.enterEndTime": "Introduzca una hora de fin.",
  "error.enterMinutes": "Introduzca los minutos.",
  "error.completeTime": "Introduzca una hora completa.",
  "error.enterEmail": "Introduzca su correo electrónico.",
  "error.validEmail": "Introduzca un correo electrónico válido.",
  "error.validPhone": "Introduzca un número de teléfono válido.",
  "error.personalEmail": "No se aceptan correos electrónicos personales.",
  "error.enterName": "Introduzca su nombre.",
  "error.enterCompany": "Introduzca su empresa.",
  "error.privacy": "Acepte para continuar.",
  "error.quickFillEmpty":
    "Pegue datos del envío o adjunte una imagen o PDF para rellenar el formulario.",
  "error.maxFiles": "Puede adjuntar hasta {max} archivos.",
  "error.maxFileMb": "Cada archivo debe tener {max} MB o menos.",
  "error.maxTotalMb": "Los adjuntos deben tener {max} MB o menos en total.",
  "error.filesSkippedType": "Se omitieron algunos archivos. Use JPEG, PNG, GIF, WebP o PDF.",
  "error.emptySkipped": "Se omitieron los archivos vacíos.",
  "error.fileEmpty": "El archivo seleccionado está vacío.",
  "error.filesEmptyOrType": "Algunos archivos estaban vacíos o no eran JPEG, PNG, GIF, WebP o PDF.",
  "error.attachType": "Adjunte un JPEG, PNG, GIF, WebP o PDF.",
  "error.subjectLong": "El asunto es demasiado largo.",
  "error.emailTextLong": "Los datos de la solicitud son demasiado largos.",
  "error.shortenSubject": "Acorte este valor para que el asunto del correo no supere {max} caracteres.",
  "error.shortenBody":
    "Acorte los datos del envío o el comentario para que el correo no supere {max} caracteres.",

  "announce.choose": "Elija cómo desea solicitar su presupuesto",
  "announce.quickfill": "Relleno rápido: pegue datos o suba un documento",
  "announce.route": "Paso 1 de 5: ruta y pedido",
  "announce.shipment": "Paso 2 de 5: datos del envío",
  "announce.services": "Paso 3 de 5: servicios adicionales",
  "announce.contact": "Paso 4 de 5: datos de contacto",
  "announce.review": "Paso 5 de 5: revise su solicitud",
  "announce.received": "Solicitud recibida",
  "announce.sendFailed": "No hemos podido enviar su solicitud",
  "announce.sendFailedAttempt": "No hemos podido enviar su solicitud (intento {n})",
  "announce.completeFields": "Complete los campos marcados antes de continuar.",
  "announce.sending": "Enviando su solicitud…",
};
